import type { QuickSuggestion, ContactCTA } from '@/types/chatbot'

/**
 * Quick suggestion buttons shown when the chat is empty.
 * Each entry uses i18n translation keys for label and message.
 */
export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'servizi',
    labelKey: 'chatbot.suggestions.services',
    messageKey: 'chatbot.suggestions.servicesMessage',
  },
  {
    id: 'prodotti',
    labelKey: 'chatbot.suggestions.products',
    messageKey: 'chatbot.suggestions.productsMessage',
  },
  {
    id: 'contatti',
    labelKey: 'chatbot.suggestions.contact',
    messageKey: 'chatbot.suggestions.contactMessage',
  },
  {
    id: 'preventivo',
    labelKey: 'chatbot.suggestions.quote',
    messageKey: 'chatbot.suggestions.quoteMessage',
  },
]

/**
 * Contact CTA buttons shown below each assistant message.
 * Leave empty to hide CTAs entirely.
 */
export const contactCTAs: ContactCTA[] = []

/**
 * Copy action buttons shown below assistant messages.
 * Allows users to quickly copy email or phone number.
 */
export interface CopyAction {
  id: string
  type: 'email' | 'phone'
  labelKey: string
  ariaLabelKey: string
  tooltipKey: string
  value: string
}

export const copyActions: CopyAction[] = [
  {
    id: 'copy-email',
    type: 'email',
    labelKey: 'chatbot.copyEmail',
    ariaLabelKey: 'chatbot.aria.copyEmail',
    tooltipKey: 'chatbot.tooltip.copyEmail',
    value: 'info@01sistemi.it',
  },
  {
    id: 'copy-phone',
    type: 'phone',
    labelKey: 'chatbot.copyPhone',
    ariaLabelKey: 'chatbot.aria.copyPhone',
    tooltipKey: 'chatbot.tooltip.copyPhone',
    value: '+39 0522 631144',
  },
]
